export {
  buildQueryString,
  sanitiseString,
  sortAlphabetically,
  toKebabCase,
  tokenList,
};

function sanitiseString(str) {
  return str.trim()
    .replace(/[^a-zA-Z0-9\s]/g, "")
    .replace(/\s+/g, " ");
}

/**
 * Convert string to kebab-case format.
 *
 * @see https://johnkavanagh.co.uk/articles/converting-between-camel-snake-and-kebab-case-in-javascript/
 */
function toKebabCase(str) {
  return sanitiseString(str)
    .toLowerCase()
    .replace(/\s+/g, "-");
}

function buildQueryString(query) {
  const queryString = Object.entries(query)
    .filter(([_k, v]) => Boolean(v))
    .map(e => e.join("=")).join("&");

  return queryString ? "?" + queryString : "";
}

/**
 * Sort alphabetically by `name` property.
 *
 * @return {number}
 */
function sortAlphabetically(a, b) {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
}

/**
 * Get space-separated string of object keys whose value is truthy.
 *
 * == Example
 *
 *   tokenList({ hello: false, hola: true, namaste: true })
 *   => "hola namaste"
 *
 * @param obj {object}
 * @return {string}
 */
function tokenList(obj) {
  return Object
    .keys(obj)
    .filter(key => !!obj[key])
    .join(" ");
}
